import { Component, OnInit, inject } from '@angular/core';
import {
 MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose
} from '@angular/material/dialog';
import { FsErrorResponse } from '@fairandsmart/angular';
import { FsApiError, PaymentSource } from '@fairandsmart/types';
import {
  CreateSourceData,
  SourceResult, StripeElement, StripeElements, StripeElementsOptions, StripeError,
} from '@stripe/stripe-js';
import {
  StripeService,
} from 'ngx-stripe';
import { EMPTY } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { MatProgressBar } from '@angular/material/progress-bar';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomerService } from '../../customer.service';

export interface AddPaymentDialogComponentData {
  service: CustomerService;
  replace: boolean;
}

@Component({
    selector: 'fs-add-payment-dialog',
    templateUrl: './add-payment-dialog.component.html',
    styleUrls: ['./add-payment-dialog.component.scss'],
    imports: [MatProgressBar, MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class AddPaymentDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<AddPaymentDialogComponent, PaymentSource | null>>(MatDialogRef);

  private stripeService = inject(StripeService);

  data = inject<AddPaymentDialogComponentData>(MAT_DIALOG_DATA);

  elements: StripeElements;

  card: StripeElement;

  pending: boolean;

  error: FsApiError | StripeError;

  ngOnInit() {
    this.initStripe();
  }

  private initStripe() {
    const elementsOptions: StripeElementsOptions = {
      locale: 'auto',
    };
    this.stripeService.elements(elementsOptions)
      .subscribe({
        next: (elements) => {
          this.elements = elements;
          // Only mount the element the first time
          if (!this.card) {
            this.card = this.elements.create('card', {
              style: {
                base: {
                  iconColor: '#666EE8',
                  color: '#31325F',
                  fontWeight: 300,
                  fontFamily: 'OpenSans, "Helvetica Neue", sans-serif',
                  fontSize: '18px',
                  '::placeholder': {
                    color: '#CFD7E0',
                  },
                },
              },
            });
            this.card.mount('#card-element');
          }
        },
      });
  }

  public setPaymentSource() {
    const payload: CreateSourceData = {};
    this.pending = true;
    this.stripeService.createSource(this.card, payload).pipe(
      mergeMap((result: SourceResult) => {
        if (result.source) {
          return this.data.service.setPaymentSource(result.source.id, this.data.replace);
        }
        if (result.error) {
          this.error = result.error;
          this.pending = false;
          console.error(result.error);
        }
        return EMPTY;
      }),
      tap((paymentSource: PaymentSource) => {
        this.dialogRef.close(paymentSource);
      }),
      catchError((response: FsErrorResponse) => {
        console.error(response);
        this.pending = false;
        this.error = response.error;
        return EMPTY;
      }),
    ).subscribe();
  }
}
